import { Box, BoxProps } from '@chakra-ui/react';

export function FormSection({
  isFirst = false,
  ...props
}: BoxProps & { isFirst?: boolean }): JSX.Element {
  return (
    <Box as="section" w="100%" mt={isFirst ? 0 : 'space_unit.x4'} {...props} />
  );
}
